<template>
  <v-speed-dial v-model="fab" fixed right bottom small transition="slide-x-transition">
    <template slot="activator">
      <v-btn @click="activateTooltip" color="accent" class="padding-button" fab>
        <v-icon>more_horiz</v-icon>
      </v-btn>
    </template>
    <div class="primary darken-1 pa-2">
      <div v-for="item in menu" :key="item.name">
        <v-layout column align-center>
          <v-flex>
            <v-btn @click="floatClick(item)" small color="blue" fab>
              <v-icon>{{item.icon}}</v-icon>
            </v-btn>
          </v-flex>
          <v-flex text-xs-center>{{item.name | single}}</v-flex>
        </v-layout>
        <v-divider/>
      </div>
    </div>
  </v-speed-dial>
</template>

<script>
export default {
  props: {
    menu: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      showTooltip: false,
      fab: false
    }
  },
  methods: {
    activateTooltip() {
      setTimeout(() => {
        this.showTooltip = !this.showTooltip
      }, 500)
    },
    customActivator(e) {
      setTimeout(() => {
        this.showTooltip = true
      }, 1000)
    },
    floatClick(item) {
      this.$emit('select', item)
    }
  },
  filters: {
    single: function(value) {
      return value.split(' ')[0]
    }
  }
}
</script>

<style scoped>
  .v-icon {
    display: flex;
  }
</style>